// Map of product types and sizes with their corresponding values
const smallSconceProduct = "smallSconceProduct";
const bigSconceProduct = 'bigSconceProduct';
const smallSconce = "smallSconce";
const bigSconce = 'bigSconce';
const bestSellersCanvas = 'bestSellersCanvas';
const bestSellersFrameCanvas = 'bestSellersFrameCanvas';
const bundle = 'bundle';
const ia = 'ia';

const PRODUCT_VARIANTS = {

    'Framed Canvas': [
        { key: '8x10', value: bestSellersCanvas },
        { key: '12x16', value: bestSellersCanvas },
        { key: '16x20', value: smallSconce },
        { key: '20x30', value: smallSconce },
        { key: '24x36', value: smallSconce },
        { key: '30x40', value: bigSconce },
        { key: '36x48', value: bigSconce },
        { key: '40x60', value: bigSconce },
        { key: '45x60', value: bigSconce }
    ],
    Print: [
        { key: '5x7', value: ia },
        { key: '8x10', value: ia },
        { key: '11x14', value: ia },
        { key: '12x16', value: ia },
        // { key: '5x7', value: `${bundle}5x7` },
        // { key: '8x10', value: `${bundle}8x10` },
        // { key: '11x14', value: `${bundle}11x14` },
        // { key: '12x16', value: `${bundle}12x16` },
        { key: '16x20', value: smallSconce },
        { key: '20x30', value: smallSconce },
        { key: '24x36', value: smallSconce },
        { key: '30x40', value: bigSconce },
        { key: '40x60', value: bigSconce }
    ],
    Canvas: [
        { key: '8x10', value: bestSellersCanvas },
        { key: '12x16', value: bestSellersCanvas },
        { key: '16x20', value: smallSconce },
        { key: '20x30', value: smallSconce },
        { key: '24x36', value: smallSconce },
        { key: '30x40', value: bigSconce },
        { key: '36x48', value: bigSconce },
        { key: '40x60', value: bigSconce },
        { key: '45x60', value: bigSconce }
    ],
    Sconce: [
        { key: '13in', value: smallSconceProduct },
        { key: '24in', value: bigSconceProduct }
    ]
};

function getProductValue(variantTitle) {
    for (const [productType, sizes] of Object.entries(PRODUCT_VARIANTS)) {
        if (variantTitle.includes(productType)) {
            const size = sizes.find(s => variantTitle.includes(s.key));
            if (size) {
                return size.value;
            }
        }
    }
    return null;
}

async function upsellLogic() {
    try {
        const response = await fetch(`${routes.cart_url}.js`);
        const cart = await response.json();
        if (!cart.items?.length) return;

        let productValue = getProductValue(cart.items[0].sku);
        if (!productValue) return;

        if(cart.items?.length > 1) {
            productValue = null;
        }

        await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    '_productType': productValue
                },
            }),
        });
    } catch (error) {
        console.error('Error in upsell logic:', error);
    }
}

window.upsellLogic = upsellLogic;